import { defineNuxtPlugin } from "nuxt/app";
import { watch } from "vue";
import { useCookieConsentStore } from "~/store/cookieConsentStore";
import { clearAllStorageByPattern } from "~/utils/cookieUtils";
import { TRACKING_VENDOR_STORAGE_PATTERNS } from "~/constants/trackingVendorStoragePatterns";

export default defineNuxtPlugin(() => {
  const cookieConsentStore = useCookieConsentStore();

  const shutdownHubSpot = () => {
    // Clear all HubSpot data (cookies, local & session storage)
    clearAllStorageByPattern(TRACKING_VENDOR_STORAGE_PATTERNS.hubSpot);
  };

  watch(
    () => cookieConsentStore.areFunctionalCookiesEnabled,
    (enabled) => {
      if (!enabled) {
        shutdownHubSpot();
      }
    },
    { immediate: true },
  );
});
